import { Injectable } from "@angular/core";
import { CanDeactivate } from "@angular/router";
import { FareRateDetailContainer } from "../containers/fare/rate/detail/fare-detail";

@Injectable()
export class DeactivateGuard implements CanDeactivate<FareRateDetailContainer> {
  constructor() {}

  canDeactivate(component: FareRateDetailContainer) {
    return component.canDeactivate();
  }
}


// WEBPACK FOOTER //
// ./src/app/guard/deactivate-guard.ts